/**
 * @flow
 * @relayHash a5a70c67cb8fe4e7b33cb43718364481
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type StravaActivitiesSelectionQueryRendererQueryVariables = {|
  accessToken: string,
  hasStravaToken: boolean,
  before?: ?any,
  after?: ?any,
|};
export type StravaActivitiesSelectionQueryRendererQueryResponse = {|
  +stravaActivities?: ?{|
    +activities: $ReadOnlyArray<{|
      +distance: number,
      +elapsedTime: number,
      +id: string,
      +name: string,
      +startDate: any,
    |}>
  |}
|};
export type StravaActivitiesSelectionQueryRendererQuery = {|
  variables: StravaActivitiesSelectionQueryRendererQueryVariables,
  response: StravaActivitiesSelectionQueryRendererQueryResponse,
|};
*/


/*
query StravaActivitiesSelectionQueryRendererQuery(
  $accessToken: String!
  $hasStravaToken: Boolean!
  $before: Date
  $after: Date
) {
  stravaActivities(accessToken: $accessToken, before: $before, after: $after) @include(if: $hasStravaToken) {
    activities {
      distance
      elapsedTime
      id
      name
      startDate
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "accessToken",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "hasStravaToken",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "before",
    "type": "Date",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "after",
    "type": "Date",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Condition",
    "passingValue": true,
    "condition": "hasStravaToken",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "stravaActivities",
        "storageKey": null,
        "args": [
          {
            "kind": "Variable",
            "name": "accessToken",
            "variableName": "accessToken"
          },
          {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
          },
          {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
          }
        ],
        "concreteType": "StravaActivities",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "activities",
            "storageKey": null,
            "args": null,
            "concreteType": "StravaActivity",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "distance",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "elapsedTime",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "startDate",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "StravaActivitiesSelectionQueryRendererQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "StravaActivitiesSelectionQueryRendererQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "StravaActivitiesSelectionQueryRendererQuery",
    "id": null,
    "text": "query StravaActivitiesSelectionQueryRendererQuery(\n  $accessToken: String!\n  $hasStravaToken: Boolean!\n  $before: Date\n  $after: Date\n) {\n  stravaActivities(accessToken: $accessToken, before: $before, after: $after) @include(if: $hasStravaToken) {\n    activities {\n      distance\n      elapsedTime\n      id\n      name\n      startDate\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '331aed6889ec24ce1e67b4cd62ceb288';

module.exports = node;
